import { Link } from 'gatsby'
import React from 'react'

import ButtonLinkArrow from './../../graphics/arrow-button-link.svg'

import styles from './styles.module.scss'

const ButtonLink = ({ className = '', to, label }) => {
    if (to.includes('http')) {
        return (
            <a href={to} className={`button ${styles['button-link']} ${className}`} target='_blank'>
                <div className={styles['button-link__icon-wrapper']}>
                    <ButtonLinkArrow className={styles['button-link__icon']} />
                </div>
                <span className={`heading-4 ${styles['button-link__label']}`}>{label}</span>
            </a>
        )
    } else if (to.includes('@')) {
        return (
            <a href={`mailto:${to}`} className={`button ${styles['button-link']} ${className}`}>
                <div className={styles['button-link__icon-wrapper']}>
                    <ButtonLinkArrow className={styles['button-link__icon']} />
                </div>
                <span className={`heading-4 ${styles['button-link__label']}`}>{label}</span>
            </a>
        )
    } else {
        return (
            <Link to={`/${to}`} className={`button ${styles['button-link']} ${className}`}>
                <div className={styles['button-link__icon-wrapper']}>
                    <ButtonLinkArrow className={styles['button-link__icon']} />
                </div>
                <span className={`heading-4 ${styles['button-link__label']}`}>{label}</span>
            </Link>
        )
    }
}

export default ButtonLink
